import React, { useState } from 'react';
import cx from 'classnames';

import IconListItem, { IconListItemProps } from '../IconListItem';

import { Heading6, Body1, Body2, Caption } from '../Typography';
import { ReactComponent as ArrowDownIcon } from '../../assets/svg/accordion-down.svg';

import { useMeasureAccordionContentHeight } from '../../app/hooks/useMeasureAccordionContentHeight';

import styles from './index.module.scss';

export interface IconListItemsAccordionProps {
  number: string;
  title: string;
  subtitle?: string;
  text?: string;
  listItems?: IconListItemProps[];
  className?: string;
  isOpenByDefault?: boolean;
}

const IconListItemsAccordion: React.FC<IconListItemsAccordionProps> = ({
  number,
  title,
  subtitle,
  text,
  listItems,
  className,
  isOpenByDefault = false,
}) => {
  const [isOpen, setIsOpen] = useState(isOpenByDefault);
  const { contentRef, contentHeight } = useMeasureAccordionContentHeight();

  const handleAccordionClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={cx(styles.wrapper, { [styles.isOpen]: isOpen }, className)}>
      <button onClick={handleAccordionClick} className={styles.header}>
        <Caption element='span' className={styles.number}>
          {number}
        </Caption>
        <div className={styles.headerTextWrapper}>
          <div className={styles.headerTitleAndIconWrapper}>
            <Heading6 className={styles.title}>{title}</Heading6>
            <ArrowDownIcon
              className={cx({
                [styles.arrowDown]: true,
                [styles.arrowUp]: isOpen,
              })}
            />
          </div>
          {subtitle && <Body2 className={styles.subtitle}>{subtitle}</Body2>}
        </div>
      </button>

      <div
        ref={contentRef}
        className={styles.contentWrapper}
        style={{ maxHeight: isOpen ? contentHeight : 0 }}
      >
        <div className={styles.content}>
          {text && <Body1 className={styles.description}>{text}</Body1>}
          {listItems && listItems.length > 0 && (
            <ul className={styles.list}>
              {listItems.map((item, index) => (
                <IconListItem
                  key={index}
                  iconUrl={item.iconUrl}
                  title={item.title}
                  text={item.text}
                  className={styles.listItem}
                />
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};
export default IconListItemsAccordion;
